import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { appNamedRoutes, linkWithParams } from '../../routes';
import { join } from 'lodash';
import { isTeacher, isChatEnabled, canAddCompletedASQ } from '../../utils/authScopes';
import { avatarUrl } from '../../utils/Formatters';

const PlayerHeader = ({ auth, locationFrom, player, playerQuestionnaireId, search, webNotesCount, showSurveyNotesModal, onAddCompletedASQ }) => {
  const { t } = useTranslation();
  if (!player) return null;
  const backLink = locationFrom ? locationFrom : { pathname: appNamedRoutes.root, search: search };
  const isFromRoot = !locationFrom || /dashboard\/?$/.test(locationFrom.pathname);
  const isFromASQ = !locationFrom || /dashboard\/asqs?$/.test(locationFrom.pathname);
  const isThatTeacher = isTeacher(auth);
  const canAddASQ = canAddCompletedASQ(auth);
  const backLinkText = isFromRoot ? t('player.backToAllChildren') : `  ${t('player.back')}`;
  const bg = { backgroundImage: avatarUrl(player) };
  return (
    <div className='o-player-header u-margin-top--base u-margin-bottom--large'>
      <div className='row'>
        <div className='column'>
          <Link className='o-sp-button o-sp-button--back' to={backLink}>
            <i className='sp-icon-arrow-left'></i>&nbsp;{backLinkText}
          </Link>
        </div>
      </div>
      <div className='row u-margin-top--base'>
        <div className='column u-flex align-middle'>
          <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
          <div className='u-flex u-flex-column'>
            <div className='u-flex u-flex-gap' style={{ alignItems: 'center' }}>
              {isFromASQ && !isThatTeacher ?
                <Link className='cs-txt-link--sp-blue' to={{pathname: linkWithParams('accountPlayer', {id: player.id})}}>
                  <strong>{player.name}</strong>
                  <br/>
                </Link>
                : <strong>{player.name}</strong>
              }
              {isChatEnabled(auth) &&
                <Link className='cs-txt-link--sp-blue'
                  to={{
                    pathname: appNamedRoutes.communicationIndividuals,
                    search: `?id=${player.id}`
                  }}
                  title={t('player.coaching')}>
                  <i className='fa fa-comments-o'></i>
                </Link>
              }
            </div>
            <div className='c-cohorts'>
              <span className='cs-txt--sp-gray'>{player.cohorts}</span>
            </div>
            <div>
              <span className='cs-txt--sp-gray'>{player.formattedAge}</span><br />
              <span className='cs-txt--sp-gray'>{join(player.careGivers, ', ')}</span>
              {player.customIds && player.customIds.map(cid => (
                <span key={cid.handle} className='cs-txt--sp-gray'>
                  <br />{cid.label}: {cid.value || '-'}
                </span>
              ))}
              {player.siblings && player.siblings.length > 0 && (
                <span className='cs-txt--sp-gray'>
                  <br />{t('player.siblings')}: {player.siblings.map((s, i) => (
                    <React.Fragment key={s.id}>
                      {i > 0 && ', '}
                      <Link className='cs-txt-link--sp-blue' to={{ pathname: linkWithParams('accountPlayer', { id: s.id }) }}>
                        {s.name}
                      </Link>
                    </React.Fragment>
                  ))}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className='column u-flex align-right u-flex-gap'>
          {!isThatTeacher && canAddASQ && (
            <button
              className='o-sp-button o-sp-button--base o-sp-button--secondary'
              onClick={onAddCompletedASQ}
            >
              Add Completed ASQ
            </button>
          )}
          {webNotesCount > 0 && playerQuestionnaireId &&
            <div className='u-flex'>
              <span className='o-player-header__notes-number u-margin-right--small'><b>{webNotesCount}</b></span>
              <span className='o-player-header__notes cs-bg--light u-pointer' onClick={showSurveyNotesModal}>
                <i className='sp-icon-list'></i>
              </span>
            </div>}
        </div>
      </div>
    </div>
  );
}

PlayerHeader.propTypes = {
  auth: PropTypes.object.isRequired,
  locationFrom: PropTypes.object,
  onAddCompletedASQ: PropTypes.func.isRequired,
  player: PropTypes.object,
  playerQuestionnaireId: PropTypes.number,
  webNotesCount: PropTypes.number.isRequired,
  search: PropTypes.string,
  showSurveyNotesModal: PropTypes.func.isRequired,
}

export default PlayerHeader;
